import { action, computed, observable } from 'mobx';
import { safeReaction } from '../util/MobxUtil';
import { pathStartsWithLang } from '../util/NavigationUtil';
import RootStore from './RootStore';
import RouteStore from './RouteStore';

export const SEGMENT_ERA = 'era';
export const SEGMENT_ARI = 'ari';
export const SEGMENT_PRIVATE: Segment = 'PRIVATE';
export const SEGMENT_BUSINESS: Segment = 'BUSINESS';

export type Segment = 'PRIVATE' | 'BUSINESS';

class SegmentStore {
  @observable accessor currentSegmentWithoutDefault: Segment | undefined;
  private routeStore: RouteStore;

  public constructor(rootStore: RootStore) {
    this.routeStore = rootStore.routeStore;

    this.setCurrentSegment();
    safeReaction(
      rootStore,
      () => this.routeStore.path,
      () => this.setCurrentSegment(),
      { fireImmediately: true },
    );
  }

  @computed
  public get currentSegment(): Segment {
    return this.currentSegmentWithoutDefault || SEGMENT_PRIVATE;
  }

  @action
  setCurrentSegment() {
    const currentCustomerSegment = this.currentCustomerPathSegment;
    if (currentCustomerSegment === SEGMENT_ARI) {
      this.currentSegmentWithoutDefault = SEGMENT_BUSINESS;
    } else if (currentCustomerSegment === SEGMENT_ERA) {
      this.currentSegmentWithoutDefault = SEGMENT_PRIVATE;
    } else {
      this.currentSegmentWithoutDefault = undefined;
    }
  }

  @computed
  private get currentCustomerPathSegment() {
    const segmentSlugIdx = pathStartsWithLang(this.routeStore.path) ? 1 : 0;
    return this.routeStore.path[segmentSlugIdx]?.toLowerCase();
  }
}

export default SegmentStore;
